import React from "react";
import clsx from "clsx";

interface NoDataStateProps {
  title?: string;
  description?: string;
  className?: string;
  icon?: React.ReactNode;
}

const NoDataState: React.FC<NoDataStateProps> = ({
  title = "No Data Available",
  description = "There is no data to display right now.",
  className,
  icon,
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-gray-200 bg-white px-6 py-12 text-center",
        className
      )}
    >
      {icon ?? (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
          <svg
            className="h-6 w-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6A2.25 2.25 0 005.25 5.25v13.5A2.25 2.25 0 007.5 21h9a2.25 2.25 0 002.25-2.25V9h-3z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 3v6h6"
            />
          </svg>
        </div>
      )}
      <div>
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
};

export default NoDataState;
